import { Middleware } from "@reduxjs/toolkit";
import { Socket } from "socket.io-client";

import {
  createVisitAsync,
  deleteVisitAsync,
  updateMultipleVisitsAsync,
  updateVisitAsync,
} from "../actions/roster";
import { updateSingleVisit } from "../reducers/roster";

export const createSocketMiddleware = (socket: Socket): Middleware => {
  return () => (next) => (action: any) => {
    const result = next(action);
    if (!socket) return result;

    switch (action.type) {
      case createVisitAsync.fulfilled.type:
        socket.emit("visit:created", action.payload?.data);
        break;

      case updateSingleVisit.type:
        // Only emit if this action is NOT from socket
        if (!action.payload?.meta?.fromSocket) {
          socket.emit("visit:singleUpdated", action.payload);
        }
        break;

      case updateVisitAsync.fulfilled.type:
        socket.emit("visit:updated", action.payload?.data);
        break;

      case updateMultipleVisitsAsync.fulfilled.type:
        socket.emit("visits:updatedMany", action.payload?.data);
        break;

      case deleteVisitAsync.fulfilled.type:
        socket.emit("visit:deleted", action.payload);
        break;

      default:
        break;
    }

    return result;
  };
};
